import $ from 'jquery';
import _ from 'lodash';
import apiFetch from '@wordpress/api-fetch';
import { smoothscroll } from "../utils/smoothscroll";

$(document).ready(function async () {
    triggeredButton();
    $('.custom-form input').blur();
    smoothscroll(0, 0, 500);
});

const triggeredButton = () => {

    const $trigger = $('.button__input');

    $trigger.click(function async (evt) {
        evt.preventDefault();
        var sendButton = $(this);
        if (!sendButton.hasClass('is-send')) {
            sendButton.addClass('is-send');
            var formElement = sendButton.closest('form');
            const formContainer = sendButton.closest('.form-container');
            var isValid = formElement.get(0).reportValidity();
            if (isValid) {
                sendForm(formElement, formContainer);
            } else {
                sendButton.removeClass('is-send');
            }
        }
    });
}

const sendForm = async (formElement, formContainer) => {
    
    const formId = formElement.attr('id');
    var formData = new FormData();
    var formParams = formElement.serializeArray();

    $.each(formElement.find('input[type="file"]'), function(i, tag) {
        $.each($(tag)[0].files, function(i, file) {
            formData.append(tag.name, file);
        });
    });

    $.each(formParams, function(i, val) {
        formData.append(val.name, val.value);
    });

    try {
        const response = await apiFetch({
            path: `mendelu/v1/form/submit/${formId}`,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            }),
            body: formData,
        });

        if (response.html.length > 0) {
            formContainer.html(response.html);
            triggeredButton();
            if (response.redirect != '' && formContainer.find('input[name="form-success"]').val() == 1) {
                window.location = response.redirect;
            } else if (formContainer.find('input[name="form-success"]').val() == 1) {
                smoothscroll(0, 0, 500);
            }
        }
    } catch (e) {
        console.log(e);
    }
  };